<svg width="24" height="24" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
 <path d="m2 17h2v0.5h-1v1h1v0.5h-2v1h3v-4h-3zm1-9h1v-4h-2v1h1zm-1 3h1.8l-1.8 2.1v0.9h3v-1h-1.8l1.8-2.1v-0.9h-3zm5-6v2h14v-2zm0 14h14v-2h-14zm0-6h14v-2h-14z"/>
</svg>
